<template>
  <section class="app">
    <router-view></router-view>
  </section>
</template>
<script>
  export default {
    data() {
      return {
      };
    },
    methods: {
    }
  };
</script>
<style lang="scss">
  .app {
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// app/app.vue